import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
// ui
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'src/@/components/ui/table';
import { Switch } from 'src/@/components/ui/switch';
// components
import Iconify from 'src/components/Iconify';
import ModalProdutos from './ModalProdutos';
import ModalImportarProdutos from './ModalImportarProdutos';
// actions
import {
    v2_actionListarProdutos,
    v2_actionCriarProduto,
    v2_actionEditarProduto,
    v2_actionDeletarProduto,
    v2_actionListarCategorias,
    v2_actionCriarCategoria,
    v2_actionEditarCategoria,
    v2_actionDeletarCategoria,
    v2_actionVerificarSkuExiste,
    v2_actionContarProdutos,
} from 'src/actions/v2/cadastro/v2_actionProdutos';
import { CADASTRO_DESIGN as D } from '../Cadastro.design';

// ----------------------------------------------------------------------

export default function ProdutosComponent({ user, cliente }) {
    const { enqueueSnackbar } = useSnackbar();
    const [openModal, setOpenModal] = useState(false);
    const [openModalImport, setOpenModalImport] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [dataProduct, setDataProduct] = useState({});
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [productLimit, setProductLimit] = useState({ count: 0, limit: 100 });

    const fetchData = async () => {
        if (cliente?._id) {
            try {
                const [prods, cats, countRes] = await Promise.all([
                    v2_actionListarProdutos(cliente._id),
                    v2_actionListarCategorias(cliente._id),
                    v2_actionContarProdutos(cliente._id)
                ]);
                setProducts(prods.data.data || prods.data || []);
                setCategories(cats.data.data || cats.data || []);
                if (countRes.data?.data) {
                    setProductLimit(countRes.data.data);
                }
            } catch (error) {
                console.error(error);
                enqueueSnackbar('Erro ao carregar dados.', { variant: 'error' });
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [cliente]);

    const handleOpenModal = async () => {
        try {
            if (cliente?._id) {
                const countResponse = await v2_actionContarProdutos(cliente._id);
                const { count, limit, available } = countResponse.data?.data || {};
                if (available !== undefined && available <= 0) {
                    enqueueSnackbar(`Limite de ${limit} produtos atingido. Exclua produtos existentes para criar novos.`, { variant: 'warning' });
                    return;
                }
            }
        } catch (error) {
            console.error('Erro ao verificar limite de produtos:', error);
        }
        setOpenModal(true);
        setIsEdit(false);
        setDataProduct({ sequence: [], tags: [], attributes: [] });
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setIsEdit(false);
        setDataProduct({});
    };

    const handleEdit = (product) => {
        setDataProduct(product);
        setIsEdit(true);
        setOpenModal(true);
    };

    const handleDelete = async (id) => {
        try {
            await v2_actionDeletarProduto(id);
            setProducts(products.filter((p) => p._id !== id));
            enqueueSnackbar('Produto excluído com sucesso!', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar('Erro ao excluir produto', { variant: 'error' });
        }
    };

    const handleSubmit = async () => {
        try {
            // Verificar se SKU já existe
            if (dataProduct?.sku) {
                const checkResponse = await v2_actionVerificarSkuExiste(cliente._id, dataProduct.sku);
                if (checkResponse.data?.data?.exists) {
                    enqueueSnackbar('Já existe um produto com este SKU/Código. Por favor, use outro.', { variant: 'warning' });
                    return;
                }
            }

            const payload = { ...dataProduct, cliente: cliente };
            const response = await v2_actionCriarProduto(payload);
            if (!response.error) {
                setProducts([...products, response.data.data || response.data]);
                enqueueSnackbar('Produto criado com sucesso!', { variant: 'success' });
                handleCloseModal();
            }
        } catch (error) {
            enqueueSnackbar('Erro ao criar produto', { variant: 'error' });
        }
    };

    const handleEditSubmit = async () => {
        try {
            // Verificar se SKU já existe (excluindo o produto atual)
            if (dataProduct?.sku) {
                const checkResponse = await v2_actionVerificarSkuExiste(cliente._id, dataProduct.sku, dataProduct._id);
                if (checkResponse.data?.data?.exists) {
                    enqueueSnackbar('Já existe outro produto com este SKU/Código. Por favor, use outro.', { variant: 'warning' });
                    return;
                }
            }

            const response = await v2_actionEditarProduto(dataProduct._id, dataProduct);
            if (!response.error) {
                const newProducts = products.map((p) => (p._id === dataProduct._id ? response.data.data || response.data : p));
                setProducts(newProducts);
                enqueueSnackbar('Produto editado com sucesso!', { variant: 'success' });
                handleCloseModal();
            }
        } catch (error) {
            enqueueSnackbar('Erro ao editar produto', { variant: 'error' });
        }
    };

    const changeName = (e) => {
        setDataProduct({ ...dataProduct, name: e.target.value });
    };

    const changeSku = (e) => {
        setDataProduct({ ...dataProduct, sku: e.target.value });
    };

    const changeRef = (e) => {
        setDataProduct({ ...dataProduct, ref: e.target.value });
    };

    const changeDescription = (e) => {
        setDataProduct({ ...dataProduct, description: e.target.value });
    };

    const changePrice = (e) => {
        setDataProduct({ ...dataProduct, price: e.target.value });
    };

    const changePriceSale = (e) => {
        setDataProduct({ ...dataProduct, priceSale: e.target.value });
    };

    const changeSale = (checked) => {
        setDataProduct({ ...dataProduct, sale: checked });
    };

    const changeStock = (e) => {
        setDataProduct({ ...dataProduct, stock: e.target.value });
    };

    const changeSequence = (newSequence) => {
        setDataProduct({ ...dataProduct, sequence: newSequence });
    };

    const changeCategory = (categoryId) => {
        setDataProduct({ ...dataProduct, category: categoryId });
    };

    const changeImage = (imageUrl) => {
        setDataProduct({ ...dataProduct, image: imageUrl });
    };

    const changeTags = (newTags) => {
        setDataProduct({ ...dataProduct, tags: newTags });
    };

    const changeAttributes = (newAttributes) => {
        setDataProduct({ ...dataProduct, attributes: newAttributes });
    };

    const changeLink = (e) => {
        setDataProduct({ ...dataProduct, link: e.target.value });
    };

    const handleToggleStatus = async (id, currentStatus) => {
        try {
            const newStatus = !currentStatus;
            const response = await v2_actionEditarProduto(id, { status: newStatus });
            if (!response.error) {
                setProducts((prev) => prev.map((p) => (p._id === id ? { ...p, status: newStatus } : p)));
                enqueueSnackbar('Status atualizado com sucesso!', { variant: 'success' });
            }
        } catch (error) {
            console.error(error);
            enqueueSnackbar('Erro ao atualizar status', { variant: 'error' });
        }
    };

    const handleCategoryActions = {
        create: async (name) => {
            try {
                const res = await v2_actionCriarCategoria({ ownerId: cliente._id, name });
                if (!res.error) setCategories([...categories, res.data.data || res.data]);
                return res.data.data || res.data;
            } catch (e) {
                console.error(e);
            }
        },
        update: async (id, name) => {
            try {
                const res = await v2_actionEditarCategoria(id, { name });
                if (!res.error) {
                    setCategories(categories.map((c) => (c._id === id ? res.data.data || res.data : c)));
                }
            } catch (e) {
                console.error(e);
            }
        },
        delete: async (id) => {
            try {
                await v2_actionDeletarCategoria(id);
                setCategories(categories.filter((c) => c._id !== id));
            } catch (e) {
                console.error(e);
            }
        },
    };

    /**
     * Como o produto aparece para a busca por foto do agente de IA.
     *
     * Quatro estados, e a diferença entre eles é o que o lojista precisa saber
     * para agir: "descartada" é definitivo enquanto a foto for aquela, então
     * ficar esperando não resolve — tem que trocar a imagem.
     *
     * As cores de "pronto" e "descartada" vão inline em vez de virarem token em
     * Cadastro.design.js: aquele arquivo ainda não está versionado (faz parte de
     * um redesenho em andamento), e acrescentar nele arrastaria o trabalho de
     * outra pessoa para dentro deste commit.
     */
    const STATUS_IA = {
        pronto: {
            rotulo: 'Busca por foto',
            classe: 'bg-[#ecfdf5] text-[#047857] border-[#a7f3d0]',
            icone: 'eva:checkmark-circle-2-outline',
            titulo: 'O agente encontra este produto quando o cliente manda uma foto parecida.',
        },
        pendente: {
            rotulo: 'Preparando',
            classe: D.badgeNeutral,
            icone: 'eva:clock-outline',
            titulo: 'A foto foi cadastrada e ainda vai ser preparada para a busca. Acontece em segundo plano.',
        },
        descartada: {
            rotulo: 'Foto não serve',
            classe: 'bg-[#fffbeb] text-[#b45309] border-[#fde68a]',
            icone: 'eva:alert-triangle-outline',
            titulo: 'Esta imagem parece um logotipo, banner ou foto genérica. Imagem assim se parece com tudo e atrapalharia o resultado, então ficou de fora. Troque por uma foto do produto.',
        },
        sem_foto: {
            rotulo: 'Sem foto',
            classe: D.badgeNeutral,
            icone: 'eva:image-outline',
            titulo: 'Sem imagem cadastrada, o agente não consegue achar este produto por foto.',
        },
    };

    const getCategoryName = (categoryData) => {
        // If category is populated object
        if (typeof categoryData === 'object' && categoryData?.name) return categoryData.name;
        // If category is just an ID string, find in categories array
        if (categoryData) {
            const catId = typeof categoryData === 'object' ? categoryData._id : categoryData;
            const found = categories.find((c) => c._id === catId || c._id?.toString() === catId?.toString());
            if (found) return found.name;
        }
        return '-';
    };

    return (
        <div className={D.root} style={{ fontFamily: D.fontStack }}>
            <div className={D.stickyHeader}>
                <div className={D.container}>
                    <div className={D.topbar}>
                        <div className={D.topbarIdentity}>
                            <h1 className={D.title}>Produtos</h1>
                            <p className={D.subtitle}>
                                Catálogo e entrega automática. {productLimit.count} de {productLimit.limit} no plano.
                            </p>
                        </div>
                        <div className={D.topbarActions}>
                            <button type="button" onClick={() => setOpenModalImport(true)} className={D.ghostButton}>
                                Importar CSV
                            </button>
                            <button type="button" onClick={handleOpenModal} className={D.primaryButton}>
                                Novo produto
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${D.container} pt-6 ${D.pageBody}`}>
            <div className={D.stack}>
            <div className={D.sectionHeader}>
                <h2 className={D.sectionHeaderTitle}>Lista</h2>
                <p className={D.sectionHeaderSub}>Clique em editar para ajustar preço, estoque e categorias.</p>
            </div>

            {products.length === 0 ? (
                <div className={D.cardFlush}>
                    <div className={D.emptyWrap}>
                        <div className={D.emptyIcon}>
                            <Iconify icon="eva:cube-outline" width={28} />
                        </div>
                        <p className={D.emptyTitle}>Nenhum produto encontrado</p>
                        <p className={D.emptyDesc}>Cadastre o primeiro produto para vender e automatizar entregas.</p>
                        <button type="button" className={`${D.link} mt-4`} onClick={handleOpenModal}>
                            Criar meu primeiro produto
                        </button>
                    </div>
                </div>
            ) : (
                <div className={D.cardFlush}>
                    <Table>
                        <TableHeader>
                            <TableRow className="hover:bg-transparent">
                                <TableHead className={`${D.tableHead} w-[72px]`}>Img</TableHead>
                                <TableHead className={D.tableHead}>Nome</TableHead>
                                <TableHead className={D.tableHead}>Categoria</TableHead>
                                <TableHead className={D.tableHead}>Tags</TableHead>
                                <TableHead className={D.tableHead}>Preço</TableHead>
                                <TableHead className={D.tableHead}>Estoque</TableHead>
                                <TableHead className={D.tableHead}>Status</TableHead>
                                <TableHead className={D.tableHead}>Agente de IA</TableHead>
                                <TableHead className={`${D.tableHead} text-right`}>Ações</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {products.map((product) => (
                                <TableRow key={product._id} className={D.tableRow}>
                                    <TableCell>
                                        <div className="w-10 h-10 rounded-lg bg-gray-100 overflow-hidden flex items-center justify-center">
                                            {product.image ? (
                                                <img src={product.image} alt="" className="w-full h-full object-cover" />
                                            ) : (
                                                <Iconify icon="solar:gallery-bold-duotone" className="text-gray-400 w-5 h-5" />
                                            )}
                                        </div>
                                    </TableCell>
                                    <TableCell className="font-medium text-gray-900">
                                        <div className="flex flex-col">
                                            <span>{product.name}</span>
                                            <div className="flex gap-2 text-[10px] text-gray-500 font-mono">
                                                {product.sku && <span>SKU: {product.sku}</span>}
                                                {product.ref && <span>REF: {product.ref}</span>}
                                            </div>
                                            <span className="text-[10px] text-gray-400 truncate max-w-[150px]">{product.description}</span>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        <span className={`${D.badge} ${D.badgeNeutral}`}>
                                            {getCategoryName(product.category)}
                                        </span>
                                    </TableCell>
                                    <TableCell>
                                        <div className="flex flex-wrap gap-1 max-w-[150px]">
                                            {product.tags?.slice(0, 2).map((tag, i) => (
                                                <span key={i} className={`${D.badge} ${D.badgeSoft} text-[11px] px-1.5 py-0.5`}>
                                                    {tag}
                                                </span>
                                            ))}
                                            {product.tags?.length > 2 && <span className="text-[11px] text-[#a1a1aa]">+{product.tags.length - 2}</span>}
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-gray-600">
                                        <div className="flex flex-col">
                                            <span>R$ {product.price}</span>
                                            {product.priceSale && <span className="text-xs text-green-600 font-medium">Promo: R$ {product.priceSale}</span>}
                                        </div>
                                    </TableCell>
                                    <TableCell className="text-gray-600">{product.stock}</TableCell>
                                    <TableCell>
                                        <Switch
                                            className={D.switch}
                                            checked={product.status !== false}
                                            onCheckedChange={() => handleToggleStatus(product._id, product.status !== false)}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {(() => {
                                            const st = STATUS_IA[product.statusBuscaImagem] || STATUS_IA.sem_foto;
                                            return (
                                                <span className={`${D.badge} ${st.classe}`} title={st.titulo}>
                                                    <Iconify icon={st.icone} width={13} />
                                                    {st.rotulo}
                                                </span>
                                            );
                                        })()}
                                    </TableCell>
                                    <TableCell className="text-right">
                                        <div className="flex justify-end gap-1.5">
                                            <button type="button" className={D.iconButton} onClick={() => handleEdit(product)}>
                                                <Iconify icon="eva:edit-2-outline" width={16} />
                                            </button>
                                            <button type="button" className={D.iconButtonDanger} onClick={() => handleDelete(product._id)}>
                                                <Iconify icon="eva:trash-2-outline" width={16} />
                                            </button>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            )}

            <ModalProdutos
                open={openModal}
                onClose={handleCloseModal}
                onSubmit={handleSubmit}
                onEdit={handleEditSubmit}
                isEdit={isEdit}
                dataProduct={dataProduct}
                changeName={changeName}
                changeSku={changeSku}
                changeRef={changeRef}
                changeDescription={changeDescription}
                changePrice={changePrice}
                changePriceSale={changePriceSale}
                changeSale={changeSale}
                changeStock={changeStock}
                changeSequence={changeSequence}
                user={user}
                cliente={cliente}
                changeCategory={changeCategory}
                changeImage={changeImage}
                changeTags={changeTags}
                changeAttributes={changeAttributes}
                changeLink={changeLink}
                categories={categories}
                categoryActions={handleCategoryActions}
            />

            <ModalImportarProdutos
                open={openModalImport}
                onClose={() => setOpenModalImport(false)}
                cliente={cliente}
                onSuccess={() => {
                    fetchData();
                }}
            />
            </div>
            </div>
        </div>
    );
}